<template>
  <b-button
    size="sm"
    variant="link"
    class="text-button-with-caret"
    v-on="$listeners">
    <b-icon-caret-left-fill
      v-if="caretPosition === 'left'"
      class="caret-icon" />
    <slot />
    <b-icon-caret-right-fill
      v-if="caretPosition === 'right'"
      class="caret-icon" />
  </b-button>
</template>

<script>
export default {
  props: {
    caretPosition: {
      type: String,
      default: 'left'
    }
  }
}
</script>

<style lang="scss" scoped>
.text-button-with-caret {
  padding: 0;
  display: flex;
  text-decoration: none;
  align-items: center;
  gap: 12px;
  color: $grey04;

  .caret-icon {
    color: $primary;
    width: 12px;
    height: 12px;
  }
}
</style>